import React from 'react'

import Audio from 'components/AudioLevelIndicator/AudioLevelIndicator'
import Network from 'components/Tiles/Indicators/Network'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'

import { Container } from './styles'

const Indicators = () => {
    const { audioTrack } = useVideoContext()
    return (
        <Container>
            <Network qualityLevel={4} addShadow />
            <Audio audioTrack={audioTrack} background="white" addShadow />
        </Container>
    )
}
export default Indicators
